import { MutationHookOptions, useMutation } from '@apollo/client';
import { ADD_BULK_PAYMENT_BUDGET_DATA } from '@frontend/app/queries/AddBulkPaymentBudgetData';
import { AddBulkPaymentBudgetData, AddBulkPaymentBudgetDataVariables } from '@frontend/app/queries/types/AddBulkPaymentBudgetData';

type IOptions = MutationHookOptions<AddBulkPaymentBudgetData, AddBulkPaymentBudgetDataVariables>;

export const useAddBulkPaymentPaymentData = (options: IOptions = {}) => useMutation<AddBulkPaymentBudgetData, AddBulkPaymentBudgetDataVariables>(ADD_BULK_PAYMENT_BUDGET_DATA, options);
